// extracted by mini-css-extract-plugin
export var activeDot = "_5r-c";
export var buttonContainer = "_5r-9";
export var channelButton = "_5r-a";
export var clickable = "_5r-d";
export var content = "_5r-0";
export var contentFull = "_5r-2";
export var contentThird = "_5r-1";
export var contentWrapper = "_5r-7";
export var description = "_5r-5";
export var heightShort = "_5r-f";
export var image = "_5r-3";
export var imageContainer = "_5r-4";
export var selectButton = "_5r-e";
export var spinnerContainer = "_5r-b";
export var titleContent = "_5r-8";
export var titleWrapper = "_5r-6";